export class KYMW0906OutputModel {
  // 配達企画回
  public deliveryCatalog = '';

  // アイテムコード
  public selectedItemCode = '';

  // 注文コード割当
  public preOrderNumQuotaCode = '';

  // 注文コード
  public orderNum = '';

  // 配達企画曜日:月
  public delivMonday = false;

  // 配達企画曜日:火
  public delivTuesday = false;

  // 配達企画曜日:水
  public delivWednesday = false;

  // 配達企画曜日:木
  public delivThursday = false;

  // 配達企画曜日:金
  public delivFriday = false;

  // 専用商品名
  public preOrderGoodsName = '';

  // 専用商品名(カナ)
  public preOrderGoodsNameKana = '';

  // 専用規格名
  public preOrderStandardName = '';

  // 専用規格名(カナ)
  public preOrderStandardNameKana = '';

  // セット企画
  public setPreOrderType = false;

  // 価格パターン
  public pricePattern = '';

  // 供給価格（通常）
  public supplyPriceStandard = '';

  // 値引区分
  public discountType = '0';

  // 値引単価
  public discountUnitPrice = '';

  // 値引率
  public discountRate = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // ポイント数
  public preOrderPoints = '';

  // 商品計画数予測リスト
  public goodsPlanNumList = [];
}
